module.exports = __webpack_public_path__ + "img/logo_x3.e0e15955.jpg";